// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.4_@module-federation+runtime-tools@2.9.0__webpack@5.110.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.4_@module-federation+runtime-tools@2.9.0__webpack@5.110.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
  display: flex;
  min-height: 48px;
  align-items: center;
}
.app-header-content-container {
  display: inherit;
  padding: 0 50px;
  flex-grow: 1;
}
.app-header-content-container div {
  display: inline-block;
}
.app-header-right-content {
  margin-left: auto;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
